<template>
  <div>
    <div class="odmik-naroci-televizija">
      <p class="navadno-besedilo">
        Vam do popolne TV sheme po vaših željam manjka le še posamezni program ali izbira programov? Preverite
        ponudbo dodatnih programskih paketov in imejte točno to, kar želite gledati.
        <br>
        Preberite več o dodatnih
        <a :href="povezavaDodatniTvProgramskiPaketi" class="primarna-barva">
          programskih paketih</a>.
      </p>
      <izdelki-box class="pt-6" v-loading="nalaganjeTvStoritev">
        <izdelek
          v-for="dp in seznamTvPaketov"
          :title="dp.naziv.toUpperCase()"
          :tag="dp.vPaketu === 1 ? 'VKLJUČENO V PAKET' : null"
          :key="dp.idStoritevVrstaIzbira"
        >
          <template v-slot:footer>
            <div class="cena">{{formatPrice(dp.vPaketu === 1 ? 0 : dp.cena)}} / mesec</div>
            <div class="orderButtonContainer">
              <template v-if="dp.vPaketu === 0">
                <OrderButton
                  v-if="dp.vklopljeno === 0  && dp.naroceno === 0 && dp.odjava_cez === null"
                  :services="[{serviceId: dp.id, quantity: 1, terminationPointId: Number.parseInt(izbranPrikljucek)}]"
                  :service-name="'TV paket ' + dp.naziv.toUpperCase()"
                  style="width: 170px;"
                  @orderConfirmed="OsveziPodatke(); $emit('orderConfirmed')"
                >
                  NAROČI PAKET
                </OrderButton>
                <OrderButton
                  v-if="dp.vklopljeno === 1  && dp.odjava_cez === null"
                  :services="[{serviceId: dp.id, quantity: 0, terminationPointId: Number.parseInt(izbranPrikljucek)}]"
                  :service-name="'TV paket ' + dp.naziv.toUpperCase()"
                  style="width: 170px;"
                  @orderConfirmed="OsveziPodatke(); $emit('orderConfirmed')"
                >
                  ODJAVI PAKET
                </OrderButton>
                <div v-if="dp.vklopljeno === 0 && dp.naroceno === 1">
                  <a class="okvir-narocilo-v-teku tekst-okvir-narocilo-v-teku">
                    NAROČILO V TEKU
                  </a>
                </div>
                <div v-if="dp.odjava_cez !== null">
                  <el-button type="primary" class="gumb-potrdi" disabled>
                    ODJAVA NA VOLJO ČEZ {{ dp.odjava_cez }} DNI
                  </el-button>
                </div>
              </template>
              <template v-else>
                <el-button
                  :class="dp.vklopljeno ? 'gumb-crni-okvir' : 'gumb-potrdi'"
                  :disabled="dp.naroceno === 1"
                  :loading="dp.loading"
                  @click="narociTvPaketi (dp.id, dp.vklopljeno ? 0 : 1, dp.naziv.toUpperCase(), dp.za_odrasle, dp)"
                >
                  {{dp.vklopljeno ? 'ODJAVI PAKET' : (dp.naroceno ? 'NAROČILO V TEKU' : 'VKLOPI PAKET')}}
                </el-button>
              </template>
            </div>
            <div v-if="dp.vPaketu === 1" class="rednaCena">Redna cena: {{formatPrice(dp.cena)}} / mesec</div>
          </template>
          <div class="px-2" style="text-align: justify;">{{dp.opis}}</div>
        </izdelek>
      </izdelki-box>
      <div>
        <InfoKomponenta/>
      </div>
      <OrderExistsInfo v-if="orderExists"/>
    </div>
  </div>
</template>
<script>
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {Button, Col} from 'element-ui'
import {povezave} from './../../../../../assets/js/Povezave/povezave'
import InfoKomponenta from './InfoKomponenta'
import OrderButton from '../../../../UIComponents/OrderButton.vue'
import OrderExistsInfo from '../../../../UIComponents/OrderExistsInfo.vue'
import Izdelek from '../../../../UIComponents/Izdelki/Izdelek.vue'
import IzdelkiBox from '../../../../UIComponents/Izdelki/IzdelkiBox.vue'
import {SlovenianCurrencyMixin} from '../../../../../assets/js/Helpers/NumberFormatMixin'


export default {
  name: 'TVpaketi',
  mixins: [SlovenianCurrencyMixin],
  emits: ['narociTvPaketi', 'orderConfirmed'],
  data () {
    return {
      nalaganjeTvStoritev: false,
      seznamDodatnihPaketov: [],
      seznamVklopljenih: [],
      seznamPridobljenihPodatkov: [],
      povezavaDodatniTvProgramskiPaketi: '',
      centerDialogVisible: false,
      pogojiHBO: false,
      uspesnoNarociloHBO: false,
      podatkiHBO: [],
      orderExists: false
    }
  },
  components: {
    IzdelkiBox,
    Izdelek,
    OrderButton,
    InfoKomponenta,
    OrderExistsInfo,
    [Button.name]: Button,
    [Col.name]: Col
  },
  props: {
    izbranPrikljucek: null,
    seznamTvPaketov: null
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.povezavaDodatniTvProgramskiPaketi = povezave.BASE_URL_DODATNI_TV_PROGRAMSKI_PAKETI
    this.OsveziPodatke()
  },
  methods: {
    async reloadOrderExists () {
      if (this.izbranPrikljucek !== null) {
        let orderExistsTmp = false
        if (this.seznamTvPaketov !== null && Array.isArray(this.seznamTvPaketov)) {
          this.seznamTvPaketov.forEach((p) => {
            if (p.naroceno > 0) {
              orderExistsTmp = true
            }
          })
        }
        this.orderExists = orderExistsTmp
      }
    },
    OsveziPodatke () {
      this.reloadOrderExists()
    },
    narociTvPaketi (izbranPaketId, status, naziv, zaOdrasle, item) {
      item.loading = true
      this.$emit('narociTvPaketi', izbranPaketId, status, 'TV paket ' + naziv, zaOdrasle)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Naroci/NarociTelevizija/TVpaketi.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociTelevizija/TVpaketi.vue